import AmexGDAB2BAboutProgram from './AmexGDAB2BAboutProgram';

export default AmexGDAB2BAboutProgram;
